import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'antd';
import { useTranslation } from 'react-i18next';

const PreRequisitesSwitch = ({
  checked,
  id,
  onChange,
  checkedText,
  uncheckedText,
  disabled
}) => {
  const { t } = useTranslation();

  return (
    <Switch
      checked={checked}
      id={id}
      onChange={onChange}
      checkedChildren={checkedText || t('quotes.form.switch.yes')}
      unCheckedChildren={uncheckedText || t('quotes.form.switch.no')}
      disabled={disabled}
      className="prerequisite-switch"
    />
  );
};

PreRequisitesSwitch.propTypes = {
  checked: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func,
  checkedText: PropTypes.string,
  uncheckedText: PropTypes.string,
  disabled: PropTypes.bool
};

PreRequisitesSwitch.defaultProps = {
  checked: false,
  id: null,
  onChange: null,
  checkedText: null,
  uncheckedText: null,
  disabled: false
};

export default PreRequisitesSwitch;
